import * as AppUrls from "constants/AppUrls";
import backArrow from "img/back-arrow.svg";
import { useHistory, useParams } from "react-router-dom";

import { AccountStatementReportAPI } from "./services/ReportServices";

import { useQuery } from "react-query";

const ReceiveInvoiceListReport = () => {
  const history = useHistory();

  const { id } = useParams();
  const pageTitle = "Bill list report";
  const backUrl = AppUrls.receive_invoices_list;

  const { data, isLoading, isSuccess } = useQuery(
    "accounts",
    AccountStatementReportAPI,
    { staleTime: Infinity, cacheTime: Infinity }
  );

  const tableHeaders = [
    "Account No",
    "Type",
    "Balance",
    "Company",
    "Contact",
    "Hub",
  ];

  const onBackClick = () => {
    history.push(backUrl);
  };

  return (
    <form>
      <div className="page-title  page-title-editable">
        <div className="w-auto">
          <div className="back-btn " onClick={onBackClick}>
            <img src={backArrow} alt="back arrow" />
            {pageTitle}
          </div>
        </div>
      </div>
      <div className="static-page">
        <div className="page-content-wrapper p-0">
          <div className="grid-container"></div>
        </div>
      </div>
    </form>
  );
};

export default ReceiveInvoiceListReport;
